import { cn } from '@/lib/classMerge'

interface ITitleProps {
  tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  text: string
  className?: string
}

const Title: React.FC<ITitleProps> = ({
  tag: Tag,
  text,
  className
}: ITitleProps) => {
  return (
    <Tag
      className={cn(
        'text-balance text-2xl font-bold text-gray-900 w-full max-w-xs lg:max-w-2xl truncate',
        'lg:text-3xl',        
        className
      )}
    >
      {text}
    </Tag>
  )
}

export default Title
